import React, { useState } from 'react';

import LoadingAircraft from './LoadingAircraft';

interface LoadingGlobalProps {
  isMounted: boolean;
}

const LoadingGlobal: React.FC<LoadingGlobalProps> = ({ isMounted }) => {
  const CSSBlock = 'loading-overlay';
  const [hide, setHide] = useState(false);
  const mountedStyle = { animation: 'globalLoadingIn 400ms ease-in-out 0s' };
  const unmountedStyle = {
    animation: 'globalLoadingOut 400ms ease-in-out 0s',
  };

  return (
    <>
      <div
        className={`${CSSBlock} ${hide ? `${CSSBlock}--hide` : ''}`}
        style={isMounted ? mountedStyle : unmountedStyle}>
        <div className={`${CSSBlock}__background`} />
      </div>
      <div
        className={`${CSSBlock} ${hide ? `${CSSBlock}--hide` : ''}`}
        style={isMounted ? mountedStyle : unmountedStyle}>
        <LoadingAircraft animated={true} />
        <div className={`clouds`}>
          <div className={`clouds-1`} />
          <div className={`clouds-2`} />
          <div className={`clouds-3`} />
          <div className={`clouds-hue`} />
        </div>
        <div className={`${CSSBlock}__wind`}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        {/* <div className={`${CSSBlock}__subtitle`}>Jet Setting ...</div> */}
      </div>
    </>
  );
};

export default LoadingGlobal;
